import { useQuery, useQueryClient } from "@tanstack/react-query";

const sidebarDataKey = 'sidebarData';

const fetchSidebarData = async () => {
    return {
        state: false,
        key: '',
        label: '',
        target: '',
        data: [],
    };
}

export const useSidebarData = () => {
    const queryClient = useQueryClient();

    const { data: sidebarData = [] } = useQuery({
        queryKey: [sidebarDataKey],
        queryFn: fetchSidebarData,
        staleTime: Infinity
    });

    const setSidebarData = (key, value) => {
        queryClient.setQueryData([sidebarDataKey], (oldData) => ({
            ...oldData,
            [key]: value,
        }));
    };

    return {
        sidebarData,
        setSidebarData,
    }
}